import { POPUP_VARIANTS } from '@v4/components/sections/Sections.const'
import AppStore from '@v4/store/appStore'
import usePopupButton from '@v4/hooks/usePopupButton'

export const useChangeEmailButton = ({ className, children, editable, onChange, action, ...rest }) => {
	const signUpRequired = AppStore.useStoreState(state => state.result.data.sing_up_required)

	const { handleClick } = usePopupButton(signUpRequired ? POPUP_VARIANTS.SING_UP_RESULT : POPUP_VARIANTS.CHANGE_EMAIL)

	return [
		{
			className,
			children,
			editable,
			rest,
		},
		{
			handleClick,
			handleChange: onChange,
		},
	]
}
